import React, { useEffect, useState } from 'react';
import { CircularProgress, Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getLegalConsents, LEGAL_DOCUMENTS } from '../../services/firebaseData';

const ALLOWED_PATHS = ['/login', '/flutter-web-login', '/legal-consents'];

export default function LegalConsentGate({ children }) {
  const { currentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [checkedKey, setCheckedKey] = useState(null);
  const mustCheck = Boolean(currentUser && !ALLOWED_PATHS.includes(location.pathname));
  const checkKey = mustCheck ? `${currentUser.uid}:${LEGAL_DOCUMENTS.termsVersion}` : null;

  useEffect(() => {
    let active = true;
    if (!mustCheck) {
      setCheckedKey(null);
      return () => { active = false; };
    }

    getLegalConsents(currentUser.uid).then((legal) => {
      if (!active) return;
      if (!legal?.termsAcceptedAt || legal.termsVersion !== LEGAL_DOCUMENTS.termsVersion || !legal?.privacyPolicyAcknowledgedAt) {
        navigate('/legal-consents', {
          replace: true,
          state: { redirectTo: location.pathname + location.search + location.hash },
        });
      } else {
        setCheckedKey(checkKey);
      }
    }).catch((error) => {
      console.error('Unable to verify legal consent:', error);
      if (active) navigate('/legal-consents', {
        replace: true,
        state: { redirectTo: location.pathname + location.search + location.hash },
      });
    });

    return () => { active = false; };
  }, [currentUser, location.pathname, location.search, location.hash, navigate, mustCheck, checkKey]);

  if (mustCheck && checkedKey !== checkKey) {
    return <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;
  }
  return children;
}
